import { render, staticRenderFns } from "./setSerial.vue?vue&type=template&id=3a8a45e0&scoped=true"
import script from "./setSerial.vue?vue&type=script&lang=js"
export * from "./setSerial.vue?vue&type=script&lang=js"
import style0 from "./setSerial.vue?vue&type=style&index=0&id=3a8a45e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8a45e0",
  null
  
)

export default component.exports